export var TopicScoreModel;
(function (TopicScoreModel) {
    TopicScoreModel["COUNT_SIGNALS"] = "count_signals";
    TopicScoreModel["TOPIC_SCORE"] = "topic_score";
    TopicScoreModel["AUTODISCOVERY_SCORE"] = "autodiscovery_score";
})(TopicScoreModel || (TopicScoreModel = {}));
//# sourceMappingURL=WeeklySnapshot.js.map